import React, { Suspense, lazy } from 'react';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
// Lazy load components that are lower in the page
const Story = lazy(() => import('./components/Story'));
const HowItWorks = lazy(() => import('./components/HowItWorks'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const CTASection = lazy(() => import('./components/CTASection'));
const FAQ = lazy(() => import('./components/FAQ'));
const Footer = lazy(() => import('./components/Footer'));
export function App() {
  return <div className="font-sans bg-[#f8f9ff] text-[#2d3748] min-h-screen" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Benefits data-id="element-3" />
        <Suspense fallback={<div className="h-96 flex items-center justify-center" data-id="element-5">
              Cargando...
            </div>} data-id="element-4">
          <Story data-id="element-6" />
          <HowItWorks data-id="element-7" />
          <Testimonials data-id="element-8" />
          <CTASection data-id="element-9" />
          <FAQ data-id="element-10" />
        </Suspense>
      </main>
      <Suspense fallback={<div data-id="element-12">Cargando...</div>} data-id="element-11">
        <Footer data-id="element-13" />
      </Suspense>
    </div>;
}